import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { isEqual } from 'lodash'
// import { Link } from 'react-router'

// Elements
import Icon from '../../../shared/elements/icon'
import Divider from '../../../shared/elements/divider'
import Inline from '../../../shared/elements/inline'

// Styles
import './section.scss'

class Section extends Component {
  constructor (props) {
    super(props)

    this.renderTitle = this.renderTitle.bind(this)
  }

  componentDidMount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  render () {
    let sectionCss = ''
    if (this.props.sectionCss !== undefined) {
      sectionCss = this.props.sectionCss
    }

    return (
      <div className={'section ' + sectionCss}>
        {this.props.title !== undefined && this.props.title !== null && this.renderTitle()}
        {this.props.children}
      </div>
    )
  }

  renderTitle () {
    return (
      <div>
        <Inline alignChildren={'center'}>
          <div>{this.props.icon !== undefined ? (<Icon icon={this.props.icon} />) : (<span className={'noIcon'}>&nbsp;</span>)}</div>
          <h3 className={'title-text' + (this.props.icon !== undefined ? '' : ' noImg')}>{this.props.title}</h3>
        </Inline>
        <Divider />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(Section)



// WEBPACK FOOTER //
// ./src/app/pages/EvaluationHistory/Section/index.js